import { useEffect, useRef, useState } from "react";
import L, { Map as LeafletMap } from "leaflet";
import "leaflet-draw";
import { MapContainer, ScaleControl, TileLayer, useMapEvents, ZoomControl } from "react-leaflet";
import { Typography, Button, ButtonGroup } from "@mui/material";
import "leaflet/dist/leaflet.css";
import "./StarlinkMaps.css";
import _ from "lodash";
import { getDecodeURI, getEncodedURI } from '../../utils/util';
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { getStarlinkMapTelemetry } from "../StarlinkDashboard/slice"
import PerformanceIcon from "../../asset/image/PerformanceIcon.svg"
import Control from "react-leaflet-custom-control";
import { VITE_ACCESS_TOKEN, VITE_USERNAME, VITE_STYLE_ID } from "../../config";
import EditActionsPopup from "../StarlinkAdmin/ServiceLines/EditActionsPopup";
import { SERVICE_FUNCTION_TO_FEATURE } from "../../config";
import { bulkUpdateServiceLineOrganization, getServiceLines, optInForServiceLine, pauseResumeServiceLine, getSubscriptionForAccount } from "../StarlinkAdmin/slice";
import Green_green from "../../asset/image/Green_green.svg"
import Green_blue from "../../asset/image/Green_blue.svg"
import Red_blue from "../../asset/image/Red_blue.svg"
import Red_red from "../../asset/image/Red_red.svg"
import NonCluster from "../../asset/image/NonCluster.svg"
import Cluster from "../../asset/image/Cluster.svg"
import StarlinkMapPopup from "./StarlinkMapPopup";
import HelpIcon from '@mui/icons-material/HelpOutlineOutlined';
import 'leaflet.markercluster';

const StarlinkMap = (props) => {
    const { location, starlinkLastLocations, history, authReducer, getServiceLines, serviceLines, pauseResumeServiceLine, optInForServiceLine, serviceLinesForAdmin,
         bulkUpdateServiceLineOrganization, getSubscriptionForAccount, selectedServiceLine, selectedServiceAccount, setSelectedServiceLine,subscriptionsForAccount,
          dpIds, getStarlinkMapTelemetry, starlinkMapTelemetry, mapClick, setMapClick, tableSearch, newSummaryServiceLine, hoveredSL, setHoveredSL, setSearchOperation, tableWidth } = props;
    const queryParams = new Map<string, string>(Object.entries(getDecodeURI(location.search)));
    const [map, setMap] = useState<LeafletMap | null>(null);
    const [zoomLevel, setZoomLevel] = useState<number>(2);
    const [selectedTerminal, setSelectedTerminal] = useState<any>(null);
    const [open, setOpen] = useState(false)
    const [selectedLocation, setSelectedLocation] = useState<{service_line_name: string; service_line_number: string; lat: number; long: number; } | null>(null);
    const [isClusterView, setIsClusterView] = useState(true);
    const markerLayerRef = useRef<any>(null);
    const skipFitBoundsRef = useRef(false);
    const [selectedServiceLineLocal, setSelectedServiceLineLocal] = useState<any>(null)
    const [starlinkMapTelemetryLocal, setStarlinkMapTelemetryLocal] = useState<any>(null)
    const prevServiceLineRef = useRef(selectedServiceLineLocal);
    const [editActionsPopup, setEditActionsPopup] = useState(false);
    const [dataForPopup, setDataForPopup] = useState(null)
    const [confirmDialog, setConfirmDialog] = useState({  isOpen: false, title: "", subTitle: "", onConfirm: {},});
    const [starlinkLocations, setStarlinkLocation] = useState<any>(null)
    const hoveredLocationRef = useRef(null);
    const [visibleCount, setVisibleCount] = useState(0);

    const [tableParams, setTableParams] = useState<{
        page: number;
        size: number;
        sortBy: any;
        sortOrder: any;
        search: string;
        serviceLineStatus: String[];
    }>({
        page: queryParams.has('page') ? parseInt(queryParams.get('page') as string) : 1,
        size: queryParams.has('size') ? parseInt(queryParams.get('size') as string) : 10,
        sortBy:  'serviceLineName',
        sortOrder: queryParams.has('sortOrder') ? queryParams.get('sortOrder') as any : 'asc',
        search: queryParams.has('search') ? queryParams.get('search') as string : '',
        serviceLineStatus: queryParams.has('serviceLineStatus') ? queryParams.get('serviceLineStatus')?.split(',') as string[] : ['true', 'false']
    });

    useEffect(() => {
        if (!_.isEmpty(starlinkLastLocations)) {
            const starlinkLocations = starlinkLastLocations.map((location: any) => {
                if (!Array.isArray(location)) return null;
                const [service_line_number = null, lat = null, long = null, service_line_name = "", status = "", user_terminals = null] = location;
                return { service_line_number, lat, long, service_line_name, status, user_terminals };
            }).filter(Boolean);

            setStarlinkLocation(starlinkLocations);
        } else {
            setStarlinkLocation(null);
        }
    }, [starlinkLastLocations]);


    useEffect(()=>{
        if(tableSearch){
            setSelectedServiceLine(null)
            setSelectedServiceLineLocal(null)
            setOpen(false)
            if (map) {
                map.setView([35, -35], 2);
                map.dragging.enable();
            }
            setSearchOperation(false)
        }
    },[tableSearch])

    useEffect(() => {
        if (selectedServiceLine) {
            setSelectedServiceLineLocal(selectedServiceLine);
            setOpen(true);
        } else {
            setSelectedServiceLineLocal(null);
            setOpen(false);
        }
    }, [selectedServiceLine]);

    useEffect(() => {
        setStarlinkMapTelemetryLocal(starlinkMapTelemetry);
    }, [starlinkMapTelemetry])

    const handleChangeTerminal = (terminal) => {
        setSelectedTerminal(terminal);
        getStarlinkMapTelemetry({
              userTerminalId: "ut" +terminal?.userTerminalId
        })
    }

    const handleInsightsClick = (row) => {
        let kits;
        if (row?.userTerminals !== '' && JSON.parse(row?.userTerminals)) {
            kits = JSON.parse(row?.userTerminals)?.map((userTerminal: any) => {
                return userTerminal?.kitSerialNumber;
            });
        }

        let params: any = getDecodeURI(location?.search);
        params.kitSerialNumber = kits.map((kit) => `'${kit}'`).join(',');
        delete params.page;
        const newTabURL = `/starlink/analytics?${getEncodedURI(params)}&serviceLineAccess=All`;
        window.open(newTabURL, "_blank");
    };

  const getIcon = (status: number, isSelected: boolean) => {
  const imageSrc = status === 1
    ? (isSelected ? Green_blue : Green_green )
    : (isSelected ? Red_blue : Red_red);

  return L.icon({
    iconUrl: imageSrc,
    iconSize: [25, 25], 
    className: "leaflet-marker-icon",
  });
};

    const MyComponent = () => {
        useMapEvents({
            zoomend: () => {
                if (map) {
                    const zoomLvl = map.getZoom();
                    setZoomLevel(zoomLvl);
                }
            },
        });
        return null;
    };

    useEffect(() => {
        if (!selectedServiceLineLocal) {
            if (map) {
                map.setView([35, -35], 2);
            }
            setOpen(false)
        }
    }, [newSummaryServiceLine])

    useEffect(() => {
        if (_.isEqual(prevServiceLineRef.current, selectedServiceLineLocal)) {
            return;
        }
        prevServiceLineRef.current = selectedServiceLineLocal;

        setSelectedTerminal(null)
        setStarlinkMapTelemetryLocal(null)

        if (!_.isEmpty(selectedServiceLineLocal) ) {
            setOpen(true);
            if (selectedServiceLineLocal?.userTerminals) {
                const terminals = JSON.parse(selectedServiceLineLocal.userTerminals || '[]');
                if (Array.isArray(terminals) && terminals.length > 0) {
                    const firstTerminal = terminals[0];
                    if (firstTerminal?.userTerminalId?.trim()) {
                        setSelectedTerminal(firstTerminal);
                        getStarlinkMapTelemetry({ userTerminalId: "ut" + firstTerminal?.userTerminalId });
                    }
                }
            }
            getServiceLines({
                accounts: selectedServiceAccount,
                dpIds,
                searchText: selectedServiceLine?.serviceLineNumber,
                sortBy: tableParams.sortBy,
                sortOrder: tableParams.sortOrder,
                page: tableParams.page,
                limit: tableParams.size,
                serviceLineStatus: tableParams.serviceLineStatus,
                serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
            })
        }

        if (!_.isEmpty(selectedServiceLineLocal) && !_.isEmpty(starlinkLocations)) {
           
            const matchingLocation = starlinkLocations?.find((location) => {
                return location.service_line_number === selectedServiceLineLocal?.serviceLineNumber;
            });

            if (matchingLocation) {
                // setSelectedLocation({
                //     service_line_name: matchingLocation.service_line_name,
                //     service_line_number: matchingLocation.service_line_number,
                //     lat: matchingLocation.lat,
                //     long: matchingLocation.long,
                // });
                if (map) {
                    // map.setView([matchingLocation.lat, matchingLocation.long + 1.0], 8);
                }
            }
        }
    }, [selectedServiceLineLocal, starlinkLocations])

    const updateVisibleCount = () => {
        if (!map || !starlinkLocations?.length) return;
        const bounds = map.getBounds();
        const count = starlinkLocations.filter(loc =>
            bounds.contains([loc.lat, loc.long])
        );
        setVisibleCount(count?.length);
    };

    useEffect(() => {
        if (!map) return;
        updateVisibleCount();
        map.on("moveend zoomend", updateVisibleCount);
        return () => {
            map.off("moveend zoomend", updateVisibleCount);
        };
    }, [map, starlinkLocations]);

    const createClusterIcon = (onlineRatio: number, total: number) =>
        L.divIcon({
            html: `
      <div style="
        position: relative;
        width: 65px;
        height: 65px;
      ">

        <!-- Donut Ring -->
        <div style="
          position: absolute;
          inset: 0;
          border-radius: 50%;
          background: conic-gradient(
            #28a745 0% ${onlineRatio}%,
            #dc3545 ${onlineRatio}% 100%
          );
          -webkit-mask: radial-gradient(circle 24px at center, transparent 24px, white 25px);
          mask: radial-gradient(circle 24px at center, transparent 24px, white 25px);
        "></div>

        <!-- Frosted Center -->
        <div style="
          position: absolute;
          top: 50%;
          left: 50%;
          width: 45px;
          height: 45px;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          backdrop-filter: blur(0.5px);
          -webkit-backdrop-filter: blur(0.5px);
          background: rgba(210, 210, 210, 0.25);
        "></div>

        <!-- Text -->
        <div style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 14px;
          font-weight: 700;
          color: black;
          mix-blend-mode: normal;
          text-shadow: 0 1px 2px rgba(255,255,255,0.7);
        ">
          ${total}
        </div>

      </div>
    `,
            className: 'custom-cluster-icon',
            iconSize: L.point(50, 50),
        });

    // useEffect(() => {
    //     if (!map) return;
    //     setIsClusterView(zoomLevel < 8);
    // }, [zoomLevel]);

    interface CustomMarkerOptions extends L.MarkerOptions { status?: 'online' | 'offline'; }

    useEffect(() => {
        if (!map || !starlinkLocations?.length) return;

        if (markerLayerRef.current) {
            markerLayerRef.current.clearLayers();
            map.removeLayer(markerLayerRef.current);
            markerLayerRef.current = null;
        }
        if (isClusterView) {
            const markerClusterGroup = L.markerClusterGroup({
                disableClusteringAtZoom: 8,
                spiderfyOnMaxZoom: true,
                showCoverageOnHover: false,

                iconCreateFunction: (cluster) => {
                    const childMarkers = cluster.getAllChildMarkers();
                    const total = childMarkers.length;
                    const online = childMarkers.filter(m => (m.options as any).status === 'online').length;
                    const offline = total - online;
                    const onlineRatio = total ? (online / total) * 100 : 0;

                     return createClusterIcon(onlineRatio, total);

                },
            });

            starlinkLocations.forEach((location) => {
                const isSelected = location.service_line_number === selectedServiceLineLocal?.serviceLineNumber;

                const marker = L.marker([location.lat, location.long], {
                    icon: getIcon(location.status, isSelected),
                    status: location.status === 1 ? 'online' : 'offline'
                } as CustomMarkerOptions);

                marker.on('click', () => {
                    skipFitBoundsRef.current = true;
                    handleMarkerClick(location);
                    map.setView([location.lat, location.long], 12);
                });

                marker.on("mouseover", (e: any) => {
                    e.originalEvent.stopPropagation();
                    if (hoveredLocationRef.current !== location) {
                        hoveredLocationRef.current = location;
                        handleMarkerHover(location);
                    }
                });

                marker.on("mouseout", () => {
                    if (hoveredLocationRef.current === location) {
                        hoveredLocationRef.current = null;
                        handleMarkerHover(null);
                    }
                });

                markerClusterGroup.addLayer(marker);
            });
            markerLayerRef.current = markerClusterGroup;
            map.addLayer(markerClusterGroup);
            if (!skipFitBoundsRef.current) {
                const allLatLngs = starlinkLocations.map(loc => L.latLng(loc.lat, loc.long));
                const bounds = L.latLngBounds(allLatLngs);
                const boundsSize = bounds.getNorthEast().distanceTo(bounds.getSouthWest());

                if (selectedServiceLineLocal) {
                    const matchedLocation = starlinkLocations.find(
                        loc => loc.service_line_number === selectedServiceLineLocal.serviceLineNumber
                    );

                    if (matchedLocation) {
                        map.setView([matchedLocation.lat, matchedLocation.long], 12);
                        skipFitBoundsRef.current = true;
                    }
                }

                if (!skipFitBoundsRef.current) {
                    if (allLatLngs.length === 1) {
                        map.setView(allLatLngs[0], 12);
                    } else if (boundsSize < 500000) {
                        map.fitBounds(bounds, { maxZoom: 12 });
                    } else {
                        // map.fitBounds(bounds);
                    }
                }
            }
        }
        else {
            const markerGroup = L.layerGroup();

            starlinkLocations.forEach((location) => {
                const isSelected =
                    location.service_line_number === selectedServiceLineLocal?.serviceLineNumber;

                const marker = L.marker([location.lat, location.long], {
                    icon: getIcon(location.status, isSelected),
                    status: location.status === 1 ? 'online' : 'offline'
                } as CustomMarkerOptions);

                marker.on("click", () => {
                    skipFitBoundsRef.current = true;
                    handleMarkerClick(location);
                    map.setView([location.lat, location.long], 12);
                });

                marker.on("mouseover", (e: L.LeafletMouseEvent) => {
                    e.originalEvent.stopPropagation();
                    if (hoveredLocationRef.current !== location) {
                        hoveredLocationRef.current = location;
                        handleMarkerHover(location);
                    }
                });

                marker.on("mouseout", () => {
                    if (hoveredLocationRef.current === location) {
                        hoveredLocationRef.current = null;
                        handleMarkerHover(null);
                    }
                });

                if (isSelected) {
                    marker.bindTooltip(location.service_line_name, {
                        direction: "top",
                        offset: [0, -zoomLevel * 2],
                        opacity: 1,
                        permanent: true,
                        className: "strMaps-custom-tooltip",
                    });
                }

                 markerGroup.addLayer(marker);
            });

              markerLayerRef.current = markerGroup;
              map.addLayer(markerGroup);
        }



        const resetTimer = setTimeout(() => {
            skipFitBoundsRef.current = false;
        }, 100);

        return () => {
            clearTimeout(resetTimer);
            if (markerLayerRef.current) {
                 markerLayerRef.current.clearLayers(); 
                map.removeLayer(markerLayerRef.current);
                markerLayerRef.current = null;
            }
        };

    }, [map, starlinkLocations, selectedServiceLineLocal, isClusterView]);

    const handleLayerClick = () => {
        if (open) {
            if (map) {
                map.setView([35, -35], 2);
                setMapClick(null)
                setSelectedServiceLineLocal(null)
                setSelectedServiceLine(null)
            }
        } else {
            if (serviceLines && serviceLines.length > 0) {
                if (_.isEmpty(selectedServiceLineLocal)) {
                    setSelectedServiceLineLocal(serviceLines[0])
                }
                setSelectedServiceLine(serviceLines[0])
            }
        }
        setOpen(!open)
    }

    useEffect(() => {
        if (mapClick) {

        } else {
            if (map) {
                map.setView([35, -35], 2);
            }
        }
    }, [mapClick])

    useEffect(()=>{
        if (!_.isEmpty(serviceLines) && selectedLocation) {
            const matchedData = Array.isArray(serviceLines) ? serviceLines.find(
                (serviceLine) => serviceLine.serviceLineNumber === selectedLocation.service_line_number
            ) : undefined;
            if (matchedData) {
                setSelectedLocation(null);
                setOpen(true);
                setSelectedServiceLineLocal(matchedData);
                setSelectedServiceLine(matchedData);
            }
        }
    }, [serviceLines, selectedLocation])


    const handleMarkerClick = (location: typeof starlinkLocations[0]) => {
        setTimeout(() => {
            setSelectedLocation(location);
            getServiceLines({
                accounts: selectedServiceAccount,
                dpIds,
                searchText: location.service_line_number,
                sortBy: tableParams.sortBy,
                sortOrder: tableParams.sortOrder,
                page: tableParams.page,
                limit: tableParams.size,
                serviceLineStatus: tableParams.serviceLineStatus,
                serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
            });
            handleClickSelect(location);
        }, 0);
    };

    const handleClickSelect = ( value ) => {
        const params: any = getDecodeURI(location.search);
            params.serviceLineAccess = value?.service_line_number;
        
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    };

    const toDMS = (deg) => {
        const degrees = Math.floor(deg);
        const minutes: any = ((deg - degrees) * 60).toFixed(2);
        const seconds: any = (((deg - degrees) * 60 - minutes) * 60).toFixed(2);
        return `${degrees}° ${minutes}'`;
    };

    const convertLatLongToCoordinates = (latitude, longitude) => {
        const latDirection = latitude >= 0 ? 'N' : 'S';
        const lonDirection = longitude >= 0 ? 'E' : 'W';

        const latInDMS = toDMS(Math.abs(latitude));
        const lonInDMS = toDMS(Math.abs(longitude));

        return `${latInDMS} ${latDirection}, ${lonInDMS} ${lonDirection}`;
    };

    const handleConvert = (latitude, longitude) => {
        const result = convertLatLongToCoordinates(parseFloat(latitude), parseFloat(longitude));
        return result;
    };

    const handleSiteClick = (row) => {
        let params = getDecodeURI(location?.search);
        params.k4Ids = `${row.location_id}:${row.site}`;
        delete params.page;
        const newTabURL = `/fleet-dashboard/sites/topology?${getEncodedURI(params)}`;
        window.open(newTabURL, "_blank");
    };

    const handleOverlayInteraction = () => {  if (map) {   map.dragging.disable();  } };

    const handleOverlayInteractionEnd = () => {  if (map) {  map.dragging.enable();  }  };

    const STARLINK_ADMIN_SF = "starlink-admin";
    const STARLINK_FULL_SF = "starlink-full";

    const starlinkAdminService = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["service"];
    const starlinkAdminFunction = SERVICE_FUNCTION_TO_FEATURE[STARLINK_ADMIN_SF]["function"];
    const [serviceLineToUpdate, setServiceLineToUpdate] = useState<any>(null);
     const [pauseData, setPauseData] = useState<any>({
            serviceLineNumber: '',
            accountNumber: '',
            accountDpId: '',
            action: '',
            endNow: false,
            serviceLineName: ''
        });
        const [product, setProduct] = useState('');
        const [endNow, setEndNow] = useState(false)
        const [rejectReason, setRejectReason] = useState('')
        const [mobilePriority, setMobilePriority] = useState(false);
           const [optInData, setOptInData] = useState<any>({
                serviceLineNumber: '',
                accountNumber: '',
                accountDpId: '',
                action: '',
                serviceLineName: ''
            });
        const [availableProducts, setAvailableProducts] = useState<{
            plan: string;
            product_reference_id: string;
        }[]>([])


    const handleCloseEditPopUp = () => {
        setEditActionsPopup(false);
    }

    const handleEdit = (serviceLine: any) => {
        setServiceLineToUpdate(serviceLine);
    }

    const handleChangeServiceLine = () => {
        getServiceLines({
            accounts: selectedServiceAccount,
            dpIds,
            searchText: tableParams.search,
            sortBy: tableParams.sortBy,
            sortOrder: tableParams.sortOrder,
            page: tableParams.page,
            limit: tableParams.size,
            serviceLineStatus: tableParams.serviceLineStatus,
            serviceLines: Array.isArray(newSummaryServiceLine) ? newSummaryServiceLine?.filter(sl => sl !== '') : [],
        });
    }

    const handleChangeSubOrg = async (dpId: string, serviceLineNumbers: string[]) => {
        await bulkUpdateServiceLineOrganization({
            serviceLineNumbers: serviceLineNumbers,
            dpId: dpId,
        });
    }

    const handleChangeEndNow = (event) => { setEndNow(event.target.value === "Yes" ? true : false) }

    const handleChangeProduct = (event) => {
        setProduct(event.target.value)
    }

    const handleOptIn = () => {
        if (optInData?.serviceLineNumber != '' && optInData?.accountDpId != '' && optInData?.accountNumber != '') {
            handleChangeOptIn(optInData?.serviceLineNumber, optInData?.accountDpId, optInData?.accountNumber, optInData.action)
        }
    }

    const ResizeHandler = ({ tableWidth }) => {

        useEffect(() => {
            setTimeout(() => {
                map?.invalidateSize()
            }, 0)
        }, [tableWidth])

        return null
    }

    const handleChangeOptIn = async (sl, accountDpId, accountNumber, action) => {
        const requestData = {
            dpId: accountDpId,
            serviceLineNumber: sl,
            accountNumber: accountNumber,
            action: action
        }
        await optInForServiceLine(requestData)
        handleChangeServiceLine()
    }

    const handlePauseResume = async () => {
        const requestData = {
            dpId: pauseData.accountDpId,
            serviceLineNumber: pauseData.serviceLineNumber,
            accountNumber: pauseData.accountNumber,
            action: pauseData.action,
            productReferenceId: product,
            endNow: endNow,
            rejectReason: rejectReason
        }
        await pauseResumeServiceLine(requestData)
        handleChangeServiceLine()
    }

    const convertSeconds = (input) => {
        let seconds = parseInt(input, 10);
        if (isNaN(seconds) || seconds < 0) {
          return "Invalid input.";
        }
        const days = Math.floor(seconds / (60 * 60 * 24));
        seconds %= 60 * 60 * 24;
        const hours = Math.floor(seconds / (60 * 60));
        seconds %= 60 * 60;
        const minutes = Math.floor(seconds / 60);
        seconds %= 60;
     
        let result = "";
        if (days > 0) result += `${days}D `;
        if (hours > 0) result += `${hours}H `;
        if (minutes > 0) result += `${minutes}M `;
        if (seconds > 0 || result === "") result += `${seconds}S`;
     
        return result.trim();
      }

       const handleMarkerHover = (location) => {
        if(location){
            setHoveredSL({nickname: location?.service_line_name})
        }else{
            setHoveredSL(null)
        }
    };

    return (
        <>
            <MapContainer
                center={[35, -35] as [number, number]}
                zoom={zoomLevel}
                minZoom={2}
                className="strMap-mapStyle"
                zoomControl={false}
                attributionControl={true}
                maxBoundsViscosity={1.0}
                maxBounds={[[-90, -180], [90, 180]]}
                scrollWheelZoom={true}
                fadeAnimation={true}
                preferCanvas={false}
                boxZoom={true}
                whenCreated={(mapInstance) => setMap(mapInstance as LeafletMap)}
            >
                <TileLayer
                    attribution='Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                    url={`https://api.mapbox.com/styles/v1/${VITE_USERNAME}/${VITE_STYLE_ID}/tiles/256/{z}/{x}/{y}@2x?access_token=${VITE_ACCESS_TOKEN}`}
                    maxZoom={19}
                />
                <ZoomControl position="topright" />
                <div className="map-counter">
                    {visibleCount} / {starlinkLocations?.length || 0}
                </div>
                <ScaleControl position="bottomright" />
                <ResizeHandler tableWidth={tableWidth} />
                
                <Control position="topright">
                    <div className="">
                        <ButtonGroup orientation="vertical" className="mapCustButtonsGroup">
                            <Button title="Insights" id="layersSel" onClick={() => { handleLayerClick() }}>
                                <img src={PerformanceIcon} alt="Performance Icon" />
                            </Button>
                             <Button title="Switch Cluster View" id="layersSel"  onClick={() => setIsClusterView((prev) => !prev)}>
                                <img src={isClusterView ? NonCluster : Cluster} className="starlink-map-switch-icon" alt="Performance Icon" />
                            </Button>
                             <Button title="Location accuracy is +/- 40Kms" id="layersSel">
                                <HelpIcon color="inherit"  />
                            </Button>
                        </ButtonGroup>
                    </div>
                </Control>
                <MyComponent />
                {open && selectedServiceLineLocal && (
                     <StarlinkMapPopup selectedServiceLineLocal={selectedServiceLineLocal}
                        handleOverlayInteraction={handleOverlayInteraction}
                        handleOverlayInteractionEnd={handleOverlayInteractionEnd}
                        setSelectedServiceLine={setSelectedServiceLine}
                        setMapClick={setMapClick}
                        open={open}
                        map={map}
                        setOpen={setOpen}
                        handleChangeTerminal={handleChangeTerminal}
                        selectedTerminal={selectedTerminal}
                        starlinkMapTelemetryLocal={starlinkMapTelemetryLocal}
                        handleInsightsClick={handleInsightsClick}
                        setEditActionsPopup={setEditActionsPopup}
                        setDataForPopup={setDataForPopup}
                        serviceLinesForAdmin={serviceLinesForAdmin}
                        handleConvert={handleConvert}
                        convertSeconds={convertSeconds}
                        handleSiteClick={handleSiteClick} />
                )}

                {hoveredSL &&
                    <div className="overlay-container-2">
                        <Typography variant="h6" className="hoveredSlDetails">
                            {hoveredSL?.accountDpName || ""}
                            {hoveredSL?.dpName ? ` / ${hoveredSL.dpName}  ` : ""}
                            {hoveredSL?.nickname ? (hoveredSL?.dpName || hoveredSL?.accountDpName ) ? ` / ${hoveredSL.nickname}` : ` ${hoveredSL.nickname}` : ""}
                        </Typography>
                    </div>}
            </MapContainer>

            {editActionsPopup ? <EditActionsPopup
                open={editActionsPopup} setOpen={() => { handleCloseEditPopUp() }}
                confirmDialog={confirmDialog} setConfirmDialog={setConfirmDialog}
                row={dataForPopup} setRow={setSelectedServiceLine} handleChangeServiceLine={handleChangeServiceLine}
                handleEdit={handleEdit} serviceLine={serviceLineToUpdate} availableCustomPlans={subscriptionsForAccount}
                onSave={handleChangeSubOrg} starlinkService={starlinkAdminService} starlinkFunction={starlinkAdminFunction}
                pauseData={pauseData} setPauseData={setPauseData} endNow={endNow} handleChangeEndNow={handleChangeEndNow} rejectReason={rejectReason} setRejectReason={setRejectReason}
                product={product} setProduct={setProduct} handleChangeProduct={handleChangeProduct} availableProducts={availableProducts} handlePauseResume={handlePauseResume}
                optInData={optInData} setOptInData={setOptInData} mobilePriority={mobilePriority} setMobilePriority={setMobilePriority} handleOptIn={handleOptIn} dpIds={dpIds}
            /> : null}
        </>
    );
};

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    errorReducer: state.errorReducer,
    dpIds: state.starlinkCloud.dpIds,
    warnings: state.starlinkDashboard.warnings,
    starlinkMapTelemetry: state.starlinkDashboard.starlinkMapTelemetry,
    subscriptionsForAccount: state.starlinkAdmin.subscriptionsForAccount,
    selectedServiceAccount: state?.authReducer?.selectedServiceAccount,
    serviceLinesForAdmin: state.starlinkAdmin.serviceLines,
});

export default withRouter(
    connect(mapStateToProps, {
        getStarlinkMapTelemetry,
        getServiceLines,
        pauseResumeServiceLine,
        optInForServiceLine,
        getSubscriptionForAccount,
        bulkUpdateServiceLineOrganization
    })(StarlinkMap)
);